/** Jalali-style start label from API; never uses create/publish dates. */
export function formatWebinarStartLabel(webinar) {
	if (!webinar) {
		return "";
	}

	const fromApi = String(webinar.j_start_datetime ?? "").trim();
	if (fromApi) {
		return fromApi;
	}

	const iso = webinar.start_datetime;
	if (!iso) {
		return "";
	}

	const parsed = new Date(iso);
	if (Number.isNaN(parsed.getTime())) {
		return "";
	}

	const datePart = new Intl.DateTimeFormat("fa-IR", {
		year: "numeric",
		month: "numeric",
		day: "numeric",
	}).format(parsed);
	const timePart = new Intl.DateTimeFormat("fa-IR", {
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hour12: false,
	}).format(parsed);

	return `${datePart} - ${timePart}`;
}

/** @returns {{ date: string, time: string } | null} */
export function parseWebinarStartParts(webinar) {
	const full = formatWebinarStartLabel(webinar);
	if (!full) {
		return null;
	}

	const dash = full.indexOf(" - ");
	if (dash >= 0) {
		return {
			date: full.slice(0, dash).trim(),
			time: full.slice(dash + 3).trim(),
		};
	}

	return { date: full, time: "" };
}
